import React, { useEffect, useState } from 'react';
//import { Html5QrcodeScanner, Html5QrcodeScanType } from 'html5-qrcode';
import { GetCluedoPista } from '../dao/GetCluedoPista';

const CluedoCharacters = () => {
    const [character, setCharacter] = useState<any>(null);
    const [scanning, setScanning] = useState(true);
    const [error, setError] = useState("");

    /*useEffect(() => {
        let scanner: Html5QrcodeScanner | null = null;
        let timer: NodeJS.Timeout;

        if (scanning) {
            // Delay initialization slightly to prevent race conditions in Strict Mode
            timer = setTimeout(() => {
                const element = document.getElementById("reader-char");
                if (element) {
                    element.innerHTML = "";

                    scanner = new Html5QrcodeScanner(
                        "reader-char",
                        {
                            fps: 10,
                            qrbox: { width: 250, height: 250 },
                            supportedScanTypes: [Html5QrcodeScanType.SCAN_TYPE_CAMERA]
                        },
                         false
                    );

                    scanner.render(async (decodedText) => {
                        console.log(`Code matched = ${decodedText}`);
                        if (scanner) {
                            try {
                                await scanner.clear();
                            } catch (e) {
                                console.error("Failed to clear scanner", e);
                            }
                        }

                        // VALIDATION
                        if (decodedText.startsWith("CHAR") || decodedText.startsWith("CENA")) {
                            setScanning(false);
                            setError("");
                            // Process character data
                            const data = await GetCluedoPista(decodedText);
                            if (data) {
                                setCharacter(data);
                            } else {
                                setError("No se ha encontrado ninguna información de personaje.");
                            }
                        } else if (decodedText.startsWith("QR")) {
                            setScanning(false);
                            setError("CÓDIGO INCORRECTO: Este código es una PISTA, no un Personaje. Usa la app CSI.");
                            setCharacter(null);
                        } else {
                            setScanning(false);
                            setError("CÓDIGO NO VÁLIDO: Formato desconocido.");
                            setCharacter(null);
                        }

                    }, (errorMessage) => {
                        // parse error, ignore it.
                    });
                }
            }, 100);
        }

        return () => {
            clearTimeout(timer);
            if (scanner) {
                try {
                    scanner.clear();
                } catch (e) {
                    // ignore
                }
            }
        };
    }, [scanning]);

     */

    return (
        <div style={{
            backgroundColor: '#f4e4bc', // Color papel antiguo / diario
            backgroundImage: 'url("https://www.transparenttextures.com/patterns/aged-paper.png")',
            color: '#2c3e50',
            minHeight: '100vh',
            fontFamily: '"Georgia", "Times New Roman", serif',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '10px',
            boxSizing: 'border-box'
        }}>
            <div style={{
                borderBottom: '4px solid #8b4513',
                width: '100%',
                textAlign: 'center',
                marginBottom: '20px',
                paddingBottom: '15px'
            }}>
                <img
                    src="/images/beirao.png"
                    alt="Logo"
                    style={{
                        maxHeight: '120px',
                        marginBottom: '10px'
                    }}
                />
                <h1 style={{ margin: 0, color: '#8b4513', fontSize: '3rem', fontStyle: 'italic', lineHeight: '1' }}>Diario de Personajes</h1>
                <small style={{ color: '#5d4037', fontSize: '1.2rem', marginTop: '5px', display: 'block' }}>Crónicas y Secretos</small>
            </div>

            {scanning ? (
                <div style={{ width: '100%', maxWidth: '600px', flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                    <div id="reader-char" style={{ border: '6px double #8b4513', borderRadius: '8px', overflow: 'hidden', backgroundColor: '#fff8dc', boxShadow: '0 5px 15px rgba(0,0,0,0.2)' }}></div>
                    <div style={{ textAlign: 'center', marginTop: '30px' }}>
                        <p className="blink" style={{ color: '#8b4513', fontWeight: 'bold', fontSize: '1.5rem' }}>ESCANEA UN PERFIL...</p>
                    </div>
                </div>
            ) : (
                <div style={{
                    width: '100%',
                    maxWidth: '800px',
                    border: '1px solid #dba766',
                    padding: '25px',
                    backgroundColor: '#fffdf0',
                    boxShadow: '10px 10px 20px rgba(0,0,0,0.2)',
                    position: 'relative',
                    marginBottom: '40px',
                    borderRadius: '2px'
                }}>
                    {/* Efecto de cinta adhesiva */}
                    <div style={{
                        position: 'absolute',
                        top: -15,
                        left: '50%',
                        transform: 'translateX(-50%)',
                        width: '150px',
                        height: '40px',
                        backgroundColor: 'rgba(255, 255, 255, 0.4)',
                        border: '1px solid rgba(0,0,0,0.05)',
                        boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                    }}></div>

                    {character ? (
                        <>
                            <div style={{ borderBottom: '3px double #8b4513', paddingBottom: '20px', marginBottom: '25px', textAlign: 'center' }}>
                                <h2 style={{ margin: 0, fontSize: '2.5rem', color: '#8b4513', textTransform: 'uppercase', letterSpacing: '2px' }}>{character.titol}</h2>
                                <span style={{ display: 'inline-block', marginTop: '10px', padding: '4px 12px', border: '2px solid #8b4513', borderRadius: '20px', fontSize: '1rem', color: '#8b4513', fontWeight: 'bold' }}>
                                    PERFIL #{character.id}
                                </span>
                            </div>

                            {character.img && (
                                <div style={{
                                    padding: '12px',
                                    marginBottom: '30px',
                                    backgroundColor: '#fff',
                                    border: '1px solid #ddd',
                                    boxShadow: '3px 3px 8px rgba(0,0,0,0.15)',
                                    transform: 'rotate(-1.5deg)'
                                }}>
                                    <img
                                        src={character.img.startsWith('http') || character.img.startsWith('data:') ? character.img : `data:image/jpeg;base64,${character.img}`}
                                        alt="Character"
                                        style={{ width: '100%', display: 'block', filter: 'sepia(40%) contrast(1.1)' }}
                                    />
                                </div>
                            )}

                            <div
                                className="journal-content"
                                style={{
                                    lineHeight: '1.8',
                                    fontSize: '1.3rem',
                                    textAlign: 'justify',
                                    color: '#2a2a2a'
                                }}
                                dangerouslySetInnerHTML={{ __html: character.descripcio }}
                            />
                        </>
                    ) : (
                        <div style={{ color: '#b71c1c', textAlign: 'center', border: '4px dashed #b71c1c', padding: '30px', backgroundColor: '#ffebee' }}>
                            <h2 style={{ margin: 0, fontSize: '2rem' }}>ERROR DE LECTURA</h2>
                            <p style={{ margin: '15px 0 0 0', fontWeight: 'bold', fontSize: '1.3rem' }}>{error}</p>
                        </div>
                    )}

                    <button
                        onClick={() => { setCharacter(null); setScanning(true); }}
                        style={{
                            marginTop: '40px',
                            background: '#8b4513',
                            color: '#fff',
                            border: 'none',
                            padding: '20px',
                            fontSize: '1.4rem',
                            cursor: 'pointer',
                            display: 'block',
                            width: '100%',
                            fontFamily: 'inherit',
                            fontWeight: 'bold',
                            borderRadius: '8px',
                            boxShadow: '0 4px 6px rgba(0,0,0,0.3)',
                            transition: 'background 0.2s, transform 0.1s'
                        }}
                        onMouseOver={(e) => { e.currentTarget.style.background = '#6d360f'; }}
                        onMouseOut={(e) => { e.currentTarget.style.background = '#8b4513'; }}
                        onTouchStart={(e) => { e.currentTarget.style.transform = 'scale(0.98)'; }}
                        onTouchEnd={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}
                    >
                        LEER OTRO PERFIL
                    </button>
                </div>
            )}
            <style>{`
                @keyframes blink { 50% { opacity: 0.5; } }
                .blink { animation: blink 1.5s infinite; }
                .journal-content table { width: 100%; border-collapse: collapse; margin-bottom: 1em; }
                .journal-content th, .journal-content td { border: 1px solid #8b4513; padding: 8px; }
                .journal-content blockquote { border-left: 4px solid #8b4513; margin: 1em 0; padding-left: 1em; font-style: italic; color: #555; }
            `}</style>
        </div>
    );
};

export default CluedoCharacters;
